export default {
    data() {
        return {
            currentFormat: 'YYYY-MM-DDTHH:mm:ssZ',
            currentDate: this.moment(),
            weekDays: ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'],
        }
    },
    methods: {
        getWeekday(date) {
            return this.moment(date).weekday()
        },
        // Переключение календаря на предыдущий месяц
        setPrevMonth() {
            this.currentDate = this.moment(this.currentDate).subtract(1, 'month')
        },
        // Переключение календаря на текущий месяц
        setNowMonth() {
            this.currentDate = this.moment()
        },
        // Переключение календаря на следующий месяц
        setNextMonth() {
            this.currentDate = this.moment(this.currentDate).add(1, 'month')
        }
    },
    computed: {
        date() {
            return this.currentDate
        },
        today() {
            return this.moment().format('YYYY-MM-DD')
        },
        month() {
            let v = this.date.format('M')
            if (v < 10) v = `0${v}`
            return v
        },
        year() {
            return this.date.format('YYYY')
        },
        numberOfDaysInMonth() {
            return this.currentDate.daysInMonth() || 31
        },
        /**
         * Список дней текущего месяца для отображения
         */
        currentMonthDays() {
            return [...Array(this.numberOfDaysInMonth)].map((day, index) => {
                const date = this.moment(`${this.year}-${this.month}-${index + 1}`)
                return {
                    date: date.format('YYYY-MM-DD'),
                    isCurrentMonth: true,
                    momentDate: date,
                }
            })
        },
        /**
         * Список дней предыдущего месяца для отображения
         */
        previousMonthDays() {
            const _currentMonthDays = this.currentMonthDays || []
            const firstDay = _currentMonthDays[0].date || ''
            const firstDayOfTheMonthWeekday = this.getWeekday(firstDay)
            const previousMonth = this.moment(`${this.year}-${this.month}-01`).subtract(1, 'month')
            // Cover first day of the month being sunday (firstDayOfTheMonthWeekday === 0)
            const visibleNumberOfDaysFromPreviousMonth = firstDayOfTheMonthWeekday ? firstDayOfTheMonthWeekday : 0
            const previousMonthLastMondayDayOfMonth = this.moment(firstDay)
                .subtract(visibleNumberOfDaysFromPreviousMonth, 'day')
                .date()

            return [...Array(visibleNumberOfDaysFromPreviousMonth)].map((day, index) => {
                const date = this.moment(
                    `${previousMonth.year()}-${previousMonth.month() + 1}-${previousMonthLastMondayDayOfMonth + index}`
                )
                return {
                    date: date.format('YYYY-MM-DD'),
                    isCurrentMonth: false,
                    momentDate: date,
                }
            })
        },
        /**
         * Список дней следующего месяца для отображения
         */
        nextMonthDays() {
            const lastDayOfTheMonthWeekday = this.getWeekday(`${this.year}-${this.month}-${this.currentMonthDays.length}`)
            const nextMonth = this.moment(`${this.year}-${this.month}-01`).add(1, 'month')
            const visibleNumberOfDaysFromNextMonth = lastDayOfTheMonthWeekday
                ? 6 - lastDayOfTheMonthWeekday
                : 6

            return [...Array(visibleNumberOfDaysFromNextMonth)].map((day, index) => {
                const date = this.moment(`${nextMonth.year()}-${nextMonth.month() + 1}-${index + 1}`)
                return {
                    date: date.format('YYYY-MM-DD'),
                    isCurrentMonth: false,
                    momentDate: date,
                }
            })
        },
        days() {
            return [...this.previousMonthDays, ...this.currentMonthDays, ...this.nextMonthDays]
        }
    },
    created () {},
}


// WEBPACK FOOTER //
// ./src/mixins/date.js